// 页面：扫码首页
// 渠道：海尔
import React from 'react';
import ReactDOM from 'react-dom';
import {initCookie} from "../../../libs/Cookie";
import Frame from './frame';
import "../../../app.less";
import {HOME} from "../../../libs/Page";

// 初始化cookie信息
initCookie("haier", HOME);

ReactDOM.render(
  <React.StrictMode>
    <Frame />
  </React.StrictMode>,
  document.getElementById('root')
);




